import { defaults } from './en';
import { patientMeasureMapper, patientTaskMapper, patientProgressNoteMapper, patientAttributeMapper, patientHCPCSMapper, travelTimeMapper, durationMinsMapper } from './valueGetters';
export const attributeKey = 'attributes';
export const faceToFaceKey = 'facetofacevisit';
export const manifestKey = 'manifests';
export const measuresKey = 'measures';
export const notesKey = 'notes';
export const tasksKey = 'tasks';
export const hcpcsKey = 'hcpcs';
export const travelTimeKey = 'traveltime';
export const durationKey = 'documentationtime';
export const detailUI = [{
  field: 'visitattrsumdto',
  title: defaults.VisitAttributes,
  key: `${attributeKey}-details`,
  mapper: patientAttributeMapper
}, {
  field: 'measuresdto',
  title: defaults.patientMeasures,
  key: `${measuresKey}-details`,
  mapper: patientMeasureMapper
}, {
  field: 'notesdto',
  title: defaults.patientProgressNotes,
  key: `${notesKey}-details`,
  mapper: patientProgressNoteMapper
}, {
  field: 'tasksdto',
  title: defaults.patientTasks,
  key: `${tasksKey}-details`,
  mapper: patientTaskMapper
}, {
  field: 'physicianservices',
  title: defaults.hcpcs,
  key: `${hcpcsKey}-details`,
  mapper: patientHCPCSMapper
}, {
  field: 'traveltime',
  title: defaults.travelTime,
  key: `${travelTimeKey}-details`,
  mapper: travelTimeMapper,
  scalar: true
}, {
  field: 'documentationtime',
  title: defaults.documentationTime,
  key: `${durationKey}-details`,
  mapper: durationMinsMapper,
  scalar: true
}];